import { Route } from 'react-router-dom';

import { AmenityDetailPage } from './pages/amenity-detail-page.js';
import { AmenityFormPage } from './pages/amenity-form-page.js';
import { AmenityListPage } from './pages/amenity-list-page.js';

export function amenityRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/amenities" element={<AmenityListPage />} />
      <Route path="/amenities/new" element={<AmenityFormPage />} />
      <Route path="/amenities/:amenityId/edit" element={<AmenityFormPage />} />
      <Route path="/amenities/:amenityId" element={<AmenityDetailPage />} />
    </>
  );
}
